export default __webpack_public_path__ + "media/images/features/jtb/hero-vege-859c994553ef05a954a956d2d7e19aa6.png";